import { Auth } from 'aws-amplify';
import React, { useState } from 'react';
import { Redirect } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { setAuthState } from '../auth/authSlice';
import Button from 'react-bootstrap/Button';
import { useAuthenticator } from "@aws-amplify/ui-react";
import { showError } from '../messages/messagesSlice';
import { showAlert } from '../alert/alertSlice';
import { selectUser } from '../auth/authSlice';
import { selectTriggerRemoveAccount, deleteAccountTriggered, deleteUserRecordsDynamo } from './removeAccountSlice';

export function RemoveAccount() {
    const removeAccount = useSelector(selectTriggerRemoveAccount);
    const [error, setError] = useState(false);
    const [isLoggedOut, setIsLoggedOut] = useState(false);
    const { authStatus } = useAuthenticator(context => [context.authStatus]);
    const user = useSelector(selectUser);
    const dispatch = useDispatch();

    const removeMyAccount = () => {
        dispatch(showAlert({
            title: "Warning",
            message: "Please confirm that you would like us to delete your account. Incase you are an administrator then please ensure that you re-assign your role to someone in your organisation before proceeding further.",
            closeButtonText: "Close",
            confirmButtonText: "Confirm",
            type: 'error',
            callBackActionId: 'removeaccount/deleteAccount'
        }));
    };
    
    React.useEffect(() => {
        if(removeAccount) {
            //remove user org survey records before deleting the user on cognito           
            dispatch(deleteAccountTriggered());
            dispatch(deleteUserRecordsDynamo(user.username));
            Auth.currentAuthenticatedUser()
            .then((user) => new Promise((resolve, reject) => {
                user.deleteUser(error => {
                    if (error) {
                        return reject(error);
                    }
                    Auth.signOut();
                    dispatch(setAuthState('unauthenticated'));
                    resolve();
                });
            }))
            .then(()=>{
                setIsLoggedOut(true);
            })
            .catch((error) => {      
                setError(error);
            });
        }
    }, [removeAccount])

    if(error) {
        dispatch(showError({ "message": "Failed to delete account. Please try again later." }));
    } else if(isLoggedOut) {
        return (
            <Redirect to="/login"/>
        )
    } else {
        return (
            <div>
                <Button onClick={removeMyAccount} variant="danger">Delete My Account</Button>
            </div>
        );
    }
}
